import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetAdProdutsUseCase extends UseCase {
  constructor({repository, getCurrentUserService, getAdProductsError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._getAdProductsError = getAdProductsError
  }

  _getUserId = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    return currentUser ? currentUser.getId() : this._getAdProductsError('[GetAdProdutsUseCase#execute] Unknow user ID')
  }

  /**
   * @return {Promise<Object, Error>}
   */
  async execute({adId}) {
    const userId = await this._getUserId()
    const response = await this._repository.getAdProducts({adId, userId})
    return response.toJSON()
  }
}
